var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./~/rc-align/~/core-js/library/modules/_html.js
// module id = 1094
// module chunks = 1